var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _path, _g2, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _g3, _path2, _g4, _g5, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNavigate = function SvgNavigate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 554 474"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#navigate_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 340,
    x: 217.228,
    y: 27,
    fill: "#fff",
    rx: 9.797
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 261.557,
    height: 85.517,
    x: 238.719,
    y: 144.491,
    fill: "#fff",
    stroke: "#EDEDED",
    strokeWidth: 0.983,
    rx: 7.372
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 236.286,
    height: 9.83,
    x: 251.354,
    y: 155.795,
    fill: "#EDEDED",
    rx: 4.915
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 91.889,
    height: 9.83,
    x: 251.354,
    y: 173.488,
    fill: "#EDEDED",
    rx: 4.915
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 142.21,
    height: 9.83,
    x: 251.354,
    y: 208.875,
    fill: "#EDEDED",
    rx: 4.915
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 85.326,
    height: 9.83,
    x: 402.315,
    y: 208.875,
    fill: "#EDEDED",
    rx: 4.915
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 117.049,
    height: 9.83,
    x: 251.354,
    y: 191.182,
    fill: "#EDEDED",
    rx: 4.915
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 26.254,
    height: 9.83,
    x: 377.155,
    y: 191.182,
    fill: "#EDEDED",
    rx: 4.915
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 75.481,
    height: 9.83,
    x: 412.162,
    y: 191.182,
    fill: "#EDEDED",
    rx: 4.915
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 135.646,
    height: 9.83,
    x: 351.995,
    y: 173.488,
    fill: "#EDEDED",
    rx: 4.915
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 261.557,
    height: 85.517,
    x: 238.719,
    y: 243.491,
    fill: "#fff",
    stroke: "#EDEDED",
    strokeWidth: 0.983,
    rx: 7.372
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 236.286,
    height: 9.83,
    x: 251.354,
    y: 254.795,
    fill: "#EDEDED",
    rx: 4.915
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 91.889,
    height: 9.83,
    x: 251.354,
    y: 272.488,
    fill: "#EDEDED",
    rx: 4.915
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 142.21,
    height: 9.83,
    x: 251.354,
    y: 307.875,
    fill: "#EDEDED",
    rx: 4.915
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 85.326,
    height: 9.83,
    x: 402.315,
    y: 307.875,
    fill: "#EDEDED",
    rx: 4.915
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 117.049,
    height: 9.83,
    x: 251.354,
    y: 290.182,
    fill: "#EDEDED",
    rx: 4.915
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 26.254,
    height: 9.83,
    x: 377.155,
    y: 290.182,
    fill: "#EDEDED",
    rx: 4.915
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 75.481,
    height: 9.83,
    x: 412.162,
    y: 290.182,
    fill: "#EDEDED",
    rx: 4.915
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 135.646,
    height: 9.83,
    x: 351.995,
    y: 272.488,
    fill: "#EDEDED",
    rx: 4.915
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 157.777,
    height: 6.564,
    x: 337.228,
    y: 47,
    fill: "#EDEDED",
    rx: 3.282
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 61.358,
    height: 6.564,
    x: 337.228,
    y: 58.813,
    fill: "#EDEDED",
    rx: 3.282
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 94.958,
    height: 6.564,
    x: 337.228,
    y: 82.443,
    fill: "#EDEDED",
    rx: 3.282
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 56.975,
    height: 6.564,
    x: 438.029,
    y: 82.443,
    fill: "#EDEDED",
    rx: 3.282
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 78.158,
    height: 6.564,
    x: 337.228,
    y: 70.629,
    fill: "#EDEDED",
    rx: 3.282
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 17.531,
    height: 6.564,
    x: 421.229,
    y: 70.629,
    fill: "#EDEDED",
    rx: 3.282
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 50.401,
    height: 6.564,
    x: 444.605,
    y: 70.629,
    fill: "#EDEDED",
    rx: 3.282
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 90.575,
    height: 6.564,
    x: 404.429,
    y: 58.813,
    fill: "#EDEDED",
    rx: 3.282
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 157.777,
    height: 6.564,
    x: 337.228,
    y: 93.006,
    fill: "#EDEDED",
    rx: 3.282
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 61.358,
    height: 6.564,
    x: 337.228,
    y: 104.82,
    fill: "#EDEDED",
    rx: 3.282
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 78.158,
    height: 6.564,
    x: 337.228,
    y: 116.635,
    fill: "#EDEDED",
    rx: 3.282
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 17.531,
    height: 6.564,
    x: 421.229,
    y: 116.635,
    fill: "#EDEDED",
    rx: 3.282
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 50.401,
    height: 6.564,
    x: 444.605,
    y: 116.635,
    fill: "#EDEDED",
    rx: 3.282
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 90.575,
    height: 6.564,
    x: 404.429,
    y: 104.82,
    fill: "#EDEDED",
    rx: 3.282
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    x: 238.228,
    y: 47,
    fill: "#EDEDED",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M295.311 71.917v36.166h-36.167V71.917zm0-5.167h-36.167c-2.841 0-5.166 2.325-5.166 5.167v36.166c0 2.842 2.325 5.167 5.166 5.167h36.167c2.842 0 5.167-2.325 5.167-5.167V71.917c0-2.842-2.325-5.167-5.167-5.167m-12.555 22.888-7.75 9.998-5.528-6.691-7.75 9.972h31z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#navigate_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 340,
    x: 37.227,
    y: 87,
    fill: "#fff",
    rx: 9.797
  }), /*#__PURE__*/React.createElement("rect", {
    width: 299,
    height: 339,
    x: 37.727,
    y: 87.5,
    stroke: "#51C394",
    rx: 9.297
  }))), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 261.557,
    height: 85.517,
    x: 59.719,
    y: 214.491,
    fill: "#fff",
    stroke: "#51C394",
    strokeWidth: 0.983,
    rx: 7.372
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 236.286,
    height: 9.83,
    x: 72.353,
    y: 225.795,
    fill: "#E2FFEA",
    rx: 4.915
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 91.889,
    height: 9.83,
    x: 72.353,
    y: 243.488,
    fill: "#E2FFEA",
    rx: 4.915
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 142.21,
    height: 9.83,
    x: 72.353,
    y: 278.875,
    fill: "#E2FFEA",
    rx: 4.915
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 85.326,
    height: 9.83,
    x: 223.315,
    y: 278.875,
    fill: "#E2FFEA",
    rx: 4.915
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    width: 117.049,
    height: 9.83,
    x: 72.353,
    y: 261.182,
    fill: "#E2FFEA",
    rx: 4.915
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    width: 26.254,
    height: 9.83,
    x: 198.155,
    y: 261.182,
    fill: "#E2FFEA",
    rx: 4.915
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    width: 75.481,
    height: 9.83,
    x: 233.162,
    y: 261.182,
    fill: "#E2FFEA",
    rx: 4.915
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    width: 135.646,
    height: 9.83,
    x: 172.995,
    y: 243.488,
    fill: "#E2FFEA",
    rx: 4.915
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    width: 261.557,
    height: 85.517,
    x: 59.719,
    y: 313.491,
    fill: "#fff",
    stroke: "#51C394",
    strokeWidth: 0.983,
    rx: 7.372
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    width: 236.286,
    height: 9.83,
    x: 72.353,
    y: 324.795,
    fill: "#E2FFEA",
    rx: 4.915
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 91.889,
    height: 9.83,
    x: 72.353,
    y: 342.488,
    fill: "#E2FFEA",
    rx: 4.915
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    width: 142.21,
    height: 9.83,
    x: 72.353,
    y: 377.875,
    fill: "#E2FFEA",
    rx: 4.915
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    width: 85.326,
    height: 9.83,
    x: 223.315,
    y: 377.875,
    fill: "#E2FFEA",
    rx: 4.915
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    width: 117.049,
    height: 9.83,
    x: 72.353,
    y: 360.182,
    fill: "#E2FFEA",
    rx: 4.915
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    width: 26.254,
    height: 9.83,
    x: 198.155,
    y: 360.182,
    fill: "#E2FFEA",
    rx: 4.915
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    width: 75.481,
    height: 9.83,
    x: 233.162,
    y: 360.182,
    fill: "#E2FFEA",
    rx: 4.915
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    width: 135.646,
    height: 9.83,
    x: 172.995,
    y: 342.488,
    fill: "#E2FFEA",
    rx: 4.915
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    width: 157.777,
    height: 6.564,
    x: 158.228,
    y: 117,
    fill: "#E2FFEA",
    rx: 3.282
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    width: 61.358,
    height: 6.564,
    x: 158.228,
    y: 128.813,
    fill: "#E2FFEA",
    rx: 3.282
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    width: 94.958,
    height: 6.564,
    x: 158.228,
    y: 152.443,
    fill: "#E2FFEA",
    rx: 3.282
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    width: 56.975,
    height: 6.564,
    x: 259.029,
    y: 152.443,
    fill: "#E2FFEA",
    rx: 3.282
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    width: 78.158,
    height: 6.564,
    x: 158.228,
    y: 140.629,
    fill: "#E2FFEA",
    rx: 3.282
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    width: 17.531,
    height: 6.564,
    x: 242.229,
    y: 140.629,
    fill: "#E2FFEA",
    rx: 3.282
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    width: 50.401,
    height: 6.564,
    x: 265.605,
    y: 140.629,
    fill: "#E2FFEA",
    rx: 3.282
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    width: 90.575,
    height: 6.564,
    x: 225.429,
    y: 128.813,
    fill: "#E2FFEA",
    rx: 3.282
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    width: 157.777,
    height: 6.564,
    x: 158.228,
    y: 163.006,
    fill: "#E2FFEA",
    rx: 3.282
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    width: 61.358,
    height: 6.564,
    x: 158.228,
    y: 174.82,
    fill: "#E2FFEA",
    rx: 3.282
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    width: 78.158,
    height: 6.564,
    x: 158.228,
    y: 186.635,
    fill: "#E2FFEA",
    rx: 3.282
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    width: 17.531,
    height: 6.564,
    x: 242.229,
    y: 186.635,
    fill: "#E2FFEA",
    rx: 3.282
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    width: 50.401,
    height: 6.564,
    x: 265.605,
    y: 186.635,
    fill: "#E2FFEA",
    rx: 3.282
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    width: 90.575,
    height: 6.564,
    x: 225.429,
    y: 174.82,
    fill: "#E2FFEA",
    rx: 3.282
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#navigate_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    x: 59.227,
    y: 117,
    fill: "#51C394",
    rx: 8
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M118.311 140.917v36.166H82.144v-36.166zm0-5.167H82.144c-2.842 0-5.166 2.325-5.166 5.167v36.166c0 2.842 2.325 5.167 5.166 5.167h36.167c2.842 0 5.167-2.325 5.167-5.167v-36.166c0-2.842-2.325-5.167-5.167-5.167m-12.555 22.888-7.75 9.998-5.528-6.691-7.75 9.972h31z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#navigate_svg__d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.518,
    height: 59.518,
    fill: "#3B7CC9",
    rx: 16,
    transform: "matrix(-1 0 0 1 443.745 342)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#navigate_svg__e)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.518,
    height: 38.518,
    fill: "#FFB800",
    rx: 10.355,
    transform: "matrix(-1 0 0 1 494.745 35)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M469.162 43.728a.584.584 0 0 0-.766.005l-1.597 1.429v-.187a.396.396 0 1 0-.793 0v.897l-.661.592a.397.397 0 0 0 .529.59l2.908-2.602 2.908 2.603a.398.398 0 1 0 .53-.591zM471.16 47.552a.396.396 0 0 0-.396.397v2.776h-3.966v-2.776a.397.397 0 0 0-.793 0v3.028a.55.55 0 0 0 .555.541h4.442a.55.55 0 0 0 .555-.543V47.95a.397.397 0 0 0-.397-.397M468.781 52.311a2.776 2.776 0 1 0 0 5.553 2.776 2.776 0 0 0 0-5.553m-1.983 2.776a1.99 1.99 0 0 1 1.586-1.943v1.718l-1.467.88a2 2 0 0 1-.119-.655m.528 1.335 1.393-.836 1.154 1.154c-.81.54-1.894.405-2.547-.318m3.108-.243-1.256-1.256v-1.779a1.98 1.98 0 0 1 1.256 3.035M484.645 49.139V47.78a.626.626 0 0 0-.625-.625h-1.129a.626.626 0 0 0-.625.625v1.358h-.794v-2.487a.686.686 0 0 0-.686-.686h-1.007a.686.686 0 0 0-.686.686v2.487h-.793v-4.363a.793.793 0 0 0-.793-.793h-.794a.793.793 0 0 0-.793.793v4.363h-.396a.397.397 0 0 1-.397-.397v-4.759a.396.396 0 1 0-.793 0v4.759c0 .657.533 1.19 1.19 1.19h9.121a.397.397 0 1 0 0-.793m-7.138 0h-.794v-4.363h.794zm3.172 0h-.793v-2.38h.793zm3.173 0h-.793v-1.19h.793zM484.645 57.07h-9.121a.397.397 0 0 1-.397-.396v-.63l1.306-1.305a.405.405 0 0 1 .561 0l.465.465a1.19 1.19 0 0 0 1.682 0l1.654-1.655a.405.405 0 0 1 .561 0l.465.465a1.19 1.19 0 0 0 1.682 0l1.423-1.422a.397.397 0 0 0-.561-.56l-1.422 1.421a.397.397 0 0 1-.561 0l-.465-.465a1.22 1.22 0 0 0-1.682 0l-1.655 1.655a.397.397 0 0 1-.561 0l-.464-.465a1.22 1.22 0 0 0-1.683 0l-.745.745v-3.008a.396.396 0 1 0-.793 0v4.759c0 .657.533 1.19 1.19 1.19h9.121a.397.397 0 1 0 0-.794"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M487.025 60.423V44.199A2.1 2.1 0 0 0 485.042 42h-19.829a2.1 2.1 0 0 0-1.983 2.199v16.224a2.1 2.1 0 0 0 1.983 2.2h6.345v.793h-1.586c-.876 0-1.586.71-1.586 1.586v.397c0 .219.177.396.396.396h12.691a.397.397 0 0 0 .397-.397v-.396c0-.876-.711-1.586-1.587-1.586h-1.586v-.794h6.345a2.1 2.1 0 0 0 1.983-2.2m-6.742 3.786c.438 0 .793.355.793.793h-11.897c0-.438.355-.793.793-.793zm-7.932-.793v-.794h5.553v.794zm12.691-1.587h-19.829a1.314 1.314 0 0 1-1.19-1.406v-.973h22.209v.973a1.313 1.313 0 0 1-1.19 1.406m1.19-17.63v14.458h-22.209V44.199a1.314 1.314 0 0 1 1.19-1.406h19.829a1.313 1.313 0 0 1 1.19 1.406M430.228 356v4h-32v-4zm-12 8v4h-20v-4zm12 0v4h-8v-4zm-20 8v4h-12v-4zm20 0v4h-16v-4zm-8 8v4h-24v-4z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "navigate_svg__a",
    width: 373.477,
    height: 413.477,
    x: 180.489,
    y: 0.261,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.369
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_578_13285"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_578_13285",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "navigate_svg__b",
    width: 373.477,
    height: 413.477,
    x: 0.489,
    y: 60.261,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.369
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_578_13285"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_578_13285",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "navigate_svg__c",
    width: 140,
    height: 140,
    x: 29.227,
    y: 97,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_578_13285"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_578_13285",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "navigate_svg__d",
    width: 152.103,
    height: 152.102,
    x: 340.58,
    y: 306.289,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.645,
    dy: 10.581
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.146
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_578_13285"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_578_13285",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "navigate_svg__e",
    width: 98.436,
    height: 98.436,
    x: 427.98,
    y: 11.889,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.712,
    dy: 6.848
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.979
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_578_13285"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_578_13285",
    result: "shape"
  })))));
};
export default SvgNavigate;